import { render, staticRenderFns } from "./vfooter.vue?vue&type=template&id=15d37374&scoped=true&"
import script from "./vfooter.vue?vue&type=script&lang=js&"
export * from "./vfooter.vue?vue&type=script&lang=js&"
import style0 from "./vfooter.vue?vue&type=style&index=0&id=15d37374&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d37374",
  null
  
)

export default component.exports